import { Capacitor } from '@capacitor/core';
import { BarcodeFormat, BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';

const CAMERA_PERMISSION_MESSAGE =
  'Camera permission is required to scan a QR code.';

async function isAndroidScannerReady() {
  if (Capacitor.getPlatform() !== 'android') {
    return true;
  }
  try {
    const { available } = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable();
    if (available) {
      return true;
    }
    await BarcodeScanner.installGoogleBarcodeScannerModule();
  } catch (err) {
    console.warn('Google barcode scanner module is not ready', err);
  }
  return false;
}

export async function scanQrCodeNative() {
  if (!Capacitor.isNativePlatform()) {
    return { mode: 'web' };
  }

  try {
    const { supported } = await BarcodeScanner.isSupported();
    if (!supported) {
      return { mode: 'web' };
    }

    if (!(await isAndroidScannerReady())) {
      return { mode: 'web' };
    }

    if (Capacitor.getPlatform() === 'ios') {
      const permission = await BarcodeScanner.requestPermissions();
      if (permission.camera !== 'granted' && permission.camera !== 'limited') {
        return { mode: 'error', message: CAMERA_PERMISSION_MESSAGE };
      }
    }

    const { barcodes } = await BarcodeScanner.scan({
      formats: [BarcodeFormat.QrCode],
    });
    const text = barcodes?.[0]?.rawValue || barcodes?.[0]?.displayValue;
    if (!text) {
      return { mode: 'cancelled' };
    }
    return { mode: 'scanned', text };
  } catch (err) {
    const message = String(err?.message || err).toLowerCase();
    if (message.includes('cancel') || message.includes('dismiss')) {
      return { mode: 'cancelled' };
    }
    return { mode: 'web' };
  }
}

export async function openQrScanner({ onScanned, onUseWeb, onError }) {
  const result = await scanQrCodeNative();
  if (result.mode === 'scanned') {
    onScanned(result.text);
    return;
  }
  if (result.mode === 'error') {
    if (onError) onError(result.message);
    return;
  }
  if (result.mode === 'cancelled') {
    return;
  }
  onUseWeb();
}
